/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Companydetails_Capital1Inputs */

const ja_company_companydetails_capital1 = /** @type {(inputs: Company_Companydetails_Capital1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8,000万円`)
};

const en_company_companydetails_capital1 = /** @type {(inputs: Company_Companydetails_Capital1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¥80,000,000`)
};

/**
* | output |
* | --- |
* | "¥80,000,000" |
*
* @param {Company_Companydetails_Capital1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_companydetails_capital1 = /** @type {((inputs?: Company_Companydetails_Capital1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Companydetails_Capital1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_companydetails_capital1(inputs)
	return en_company_companydetails_capital1(inputs)
});
export { company_companydetails_capital1 as "company_companyDetails_capital" }